import React, { Component } from 'react';

import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Link from '../../../shared/Link/Link';
import Button from '../../../shared/Button/Button';
import RadioContainer from '../../../shared/FormFields/RadioContainer';

import { jsx, css } from '@emotion/core';

import { FaSpinner, FaThumbsDown } from 'react-icons/fa';

import {
  setPaymentType,
  createOrder,
} from '../../../../redux/modules/checkout';
import {
  getCartTotalWithExpenses,
  getCartTotalDiscountedCoupon,
} from '../../../../redux/modules/cart';

import Price from '../../../shared/Price/Price';
import {
  checkoutStep,
  checkoutStepOptionEvent,
} from '../../../shared/lib/gaEnhancedEcommerce';
import CartaCreditoPaypal from '../../../shared/Icons/CartaCreditoPaypal';
import BonificoBancario from '../../../shared/Icons/BonificoBancario';
import Contrassegno from '../../../shared/Icons/Contrassegno';
import Satispay from '../../../shared/Icons/Satispay';
import Paypal from '../../../shared/Icons/Paypal';
import CarteNexi from '../../../shared/Icons/CarteNexi';
import CarteNexiOneLine from '../../../shared/Icons/CarteNexiOneLine';
import CartePaypal from '../../../shared/Icons/CartePaypal';

import './Pagamento.scss';
import { getAuthHeaders, getHeaders } from '../../../../api';

import Config from '../../../../config';
import { ga4AddPaymentInfo } from '../../../shared/lib/ga4EnhancedEcommerce';
import { fkmxAddPaymentInfo } from '../../../shared/lib/farmakomMetrics';

const apiUrl = Config.apiBaseHost + Config.apiBasePath;

class Pagamento extends Component {
  constructor(props) {
    super(props);

    this.state = {
      savingOrder: false,
      withRicetta: false,
      paypalBoxHeight: 100,
    };
  }

  ///////////////////////////////////
  // GOOGLE ANALYTICS STEP 4
  gaStep4(cart) {
    const productsGA = cart.map(p => ({
      id: p.code || '',
      name: p.name,
      category: p.categoryName,
      brand: p.brand,
      price: p.price,
      quantity: p.quantity,
    }));
    // SEND EVENT AFTER 1 SEC
    setTimeout(() => {
      checkoutStep(productsGA, 4);
    }, 1000);
  }

  componentDidMount() {
    const { user, checkout } = this.props;

    // rimuovo il componente per permettere il pagamento tramite ospite

    if (!checkout.doneShipping) {
      this.props.router.push('/carrello');
    }

    // GOOGLE ANALYTICS STEP 4
    if (this.props.advancedGa && this.props.cart) {
      this.gaStep4(this.props.cart);
    }

    // CHECK IF PRODUCT WITH RICETTA
    this.setState({
      withRicetta: this.props.cart.find(product => !!product.prescription),
    });

    // if (!!user.authenticated && !!checkout.doneShipping) {
    if (!!checkout.doneShipping) {
      if (!!this.props.hasPaypalAdvanced) {
        this.loadPaypalAdvancedScript();
      }
      if (!!this.props.hasPaypalPayIn3) {
        this.loadPaypalPayIn3Script();
      }
    }

    // Set is mobile & paypal box height
    this.setState({
      paypalBoxHeight:
        ((!!document &&
          !!document.getElementById('payload_advanced_box') &&
          document.getElementById('payload_advanced_box').offsetHeight) ||
          0) + 50,
    });
  }

  componentWillReceiveProps(nextProps) {
    // GOOGLE ANALYTICS STEP 4
    if (nextProps.advancedGa && nextProps.cart !== this.props.cart) {
      this.gaStep4(nextProps.cart);
    }
  }

  componentDidUpdate(oldProps) {
    if (oldProps.checkout.paymentType !== this.props.checkout.paymentType) {
      if (
        this.props.checkout.paymentType === 'paypal_pay_in_3' &&
        !!window.paypal
      ) {
        this._renderPaypalPayLaterMessage(100);
        // multiple times because somebrowser takes more time
        // but we still want to show it as soon as we can
        this._renderPaypalPayLaterMessage(250);
        this._renderPaypalPayLaterMessage(500);
      }
    }
  }

  _renderPaypalPayLaterMessage = ms => {
    setTimeout(() => {
      window.paypal
        .Messages({
          amount: this.props.cartTotalWithExpenses,
          placement: 'payment',
        })
        .render('#pp-pay-later-message');
    }, ms);
  };

  loadPaypalAdvancedScript = () => {
    const { cartTotalWithExpenses, user, storeId, checkout } = this.props;

    const scriptPaypalAdvanced = document.createElement('script');
    scriptPaypalAdvanced.id = 'paypal_advanced_script';
    scriptPaypalAdvanced.innerHTML = `
      let orderId;

      // Displays PayPal buttons
      paypal
        .Buttons({
          style: {
            layout: "horizontal",
          },
          createOrder: function (data, actions) {
            console.log("createOrder", data, actions);
            return actions.order.create({
              purchase_units: [
                {
                  amount: {
                    value: "${cartTotalWithExpenses.toFixed(2)}"
                  },
                },
              ],
            });
          },
          onApprove: function (createData, actions) {
            document.getElementById("paypal-button-container").classList.add("loader");
            document.getElementById("paypal_advanced_cc_button").disabled = true;

            orderId = createData.orderID;

            console.log("paypal button - paypal order created - now capturing");

            const order = '${JSON.stringify(this.prepareOrder())}';
            const data = {
              ...JSON.parse(order),
              paymentType: "paypal_advanced",
              transactionId: orderId,
            };
            console.log("data", data);
            
            const headers = '${
              checkout.guestCheckout
                ? JSON.stringify(getHeaders(true))
                : JSON.stringify(getAuthHeaders())
            }';

            fetch("${apiUrl}/orders", {
              method: "post",
              headers: {
                storeid: ${storeId},
                ...JSON.parse(headers),
              },
              body: JSON.stringify(data),
            })
              .then(function (res) {
                return res.json();
              })
              .then(function (orderData) {
                // se non c'è orderData.id vuol dire che è fallita la creazione dell'ordine
                if (orderData && orderData.id) {
                  // procedo ad incassare il pagamento e gestisco la risposta da api
                  const data = {
                    orderId: orderData.id
                  };
                  fetch("${apiUrl}/payments/paypal/advanced/capture", {
                    method: "POST",
                    headers: {
                      ${
                        !!localStorage.getItem('token')
                          ? `"Authorization": "Bearer ${localStorage.getItem(
                              'token'
                            )}",`
                          : ''
                      }
                      "storeid": ${storeId},
                    },
                    body: JSON.stringify(data),
                  })
                    .then(function (res) {
                      return res.json();
                    })
                    .then(function (data) {
                      console.log("data", data);
                      window.location.href = data.redirectUrl;
                    })
                    .catch(function (err) {
                      console.log("Error capturing payment", err);
                      window.location.href = "/checkout-failure";
                    })
                } else {
                  console.log("Order not created", err);
                  window.location.href = "/checkout-failure";
                }
              });
          },
        })
        .render("#paypal-button-container");
      
      // If this returns false or the card fields aren't visible, see Step #1.
      if (paypal.HostedFields.isEligible()) {
        // Renders card fields
        paypal.HostedFields.render({
          // Call your server to set up the transaction
          createOrder: function () {
            console.log("paypal cc - creating order");
            
            document.getElementById("paypal-button-container").style.opacity = 0.5;
            document.getElementById("paypal_advanced_cc_button").classList.add("loader");
            document.getElementById("paypal_advanced_cc_button").style["border-radius"] = "50% !important";
            
            const container = document.getElementById("paypal_advanced_cc_button_container");
            const e = document.getElementById("error_3d_secure");

            if (e) {
              container.removeChild(e);
            }
            
            const data = {
              amount: ${cartTotalWithExpenses},
            };
            return fetch("${apiUrl}/payments/paypal/advanced/create", {
              method: "POST",
              headers: {
                ${
                  !!localStorage.getItem('token')
                    ? `"Authorization": "Bearer ${localStorage.getItem(
                        'token'
                      )}",`
                    : ''
                }
                "storeid": ${storeId},
              },
              body: JSON.stringify(data),
            })
              .then(function (res) {
                return res.json();
              })
              .then(function (orderData) {
                console.log("fk data", orderData);
                orderId = orderData.id;
                return orderId;
              })
              .catch(function (err) {
                console.log("Error creating order", err);
                return err;
              });
          },
      
          styles: {
            ".valid": {
              color: "green",
            },
            ".invalid": {
              color: "red",
            },
          },
      
          fields: {
            number: {
              selector: "#card-number",
              placeholder: "4543 5435 9283 3244",
            },
            cvv: {
              selector: "#cvv",
              placeholder: "123",
            },
            expirationDate: {
              selector: "#expiration-date",
              placeholder: "MM/AA",
            },
          },
        }).then(function (cardFields) {
          document.querySelector("#card-form").addEventListener("submit", (event) => {
            event.preventDefault();
            
            console.log("submitted");

            const cardFieldsData = {
              // Cardholder's first and last name
              cardholderName: document.getElementById('card-holder-name').value,
              // Billing Address
              billingAddress: {
                // Street address, line 1
                streetAddress: "${user.data.billing.address1}",
                // Street address, line 2 (Ex: Unit, Apartment, etc.)
                extendedAddress: "${user.data.billing.address2}",
                // State
                region: "${user.data.billing.province}",
                // City
                locality: "${user.data.billing.city}",
                // Postal Code
                postalCode: "${user.data.billing.zipcode}",
                // Country Code
                countryCodeAlpha2: "IT",
              },

              // Trigger 3D Secure authentication
              contingencies: ['SCA_WHEN_REQUIRED']
            };

            console.log("Card fields data", cardFieldsData);

            cardFields
              .submit(cardFieldsData)
              // 3D Secure
              .then(function (payload) {
                // sample payload
                // {
                //   authenticationReason: "ERROR"
                //   authenticationStatus: "ERROR"
                //   card: undefined
                //   liabilityShift: "NO"
                //   liabilityShifted: false
                //   orderId: "7NS32496NH263812L"
                // }
                // reference doc: https://developer.paypal.com/docs/checkout/advanced/customize/3d-secure/response-parameters/

                console.log("3D payload", payload);
                const { liabilityShifted, authenticationStatus, authenticationReason } = payload;

                // Needed only when 3D Secure contingency applied

                if (payload.liabilityShift === "POSSIBLE") {
                  // 3D Secure passed successfully
                  return true;
                } else {
                  throw new Error('Error_3DSecure');
                }

                // if (payload.liabilityShift) {
                //      // Handle buyer confirmed 3D Secure successfully

                //     if (
                //        typeof liabilityShifted === "undefined" &&
                //        typeof authenticationStatus === "undefined" &&
                //        typeof authenticationReason === "undefined"
                //      ) {
                //        return true;
                //      }
                     
                //      if (
                //        !!liabilityShifted &&
                //        authenticationStatus === "YES" &&
                //        authenticationReason === "SUCCESSFUL"
                //      ) {
                //        return true;
                //      }
                     
                //      if (
                //        !liabilityShifted
                //      ) {
                //       if (authenticationStatus === "NO") {
                //         if (
                //           authenticationReason === "BYPASSED" ||
                //           authenticationReason === "ATTEMPTED" ||
                //           authenticationReason === "UNAVAILABLE" ||
                //           authenticationReason === "CARD_INELIGIBLE"
                //         ) {
                //           return true;
                //         }
                //       }
                //        throw new Error('Error_3DSecure');
                //      }

                //      throw new Error('Error_3DSecure');
                // }
              })
              .then(function () {
                console.log("paypal cc - order created - now capturing");

                const order = '${JSON.stringify(this.prepareOrder())}';
                const data = {
                  ...JSON.parse(order),
                  paymentType: "paypal_advanced",
                  transactionId: orderId,
                };
                console.log("data", data);
                
                const headers = '${
                  checkout.guestCheckout
                    ? JSON.stringify(getHeaders(true))
                    : JSON.stringify(getAuthHeaders())
                }';

                fetch("${apiUrl}/orders", {
                  method: "post",
                  headers: {
                    storeid: ${storeId},
                    ...JSON.parse(headers),
                  },
                  body: JSON.stringify(data),
                })
                  .then(function (res) {
                    return res.json();
                  })
                  .then(function (orderData) {
                    // se non c'è orderData.id vuol dire che è fallita la creazione dell'ordine
                    if (orderData && orderData.id) {
                      // procedo ad incassare il pagamento e gestisco la risposta da api
                      const data = {
                        orderId: orderData.id
                      };
                      fetch("${apiUrl}/payments/paypal/advanced/capture", {
                        method: "POST",
                        headers: {
                          ${
                            !!localStorage.getItem('token')
                              ? `"Authorization": "Bearer ${localStorage.getItem(
                                  'token'
                                )}",`
                              : ''
                          }
                          "storeid": ${storeId},
                        },
                        body: JSON.stringify(data),
                      })
                        .then(function (res) {
                          return res.json();
                        })
                        .then(function (data) {
                          console.log("data", data);
                          window.location.href = data.redirectUrl;
                        })
                        .catch(function (err) {
                          console.log("Error capturing payment", err);
                          window.location.href = "/checkout-failure";
                        })
                    } else {
                      console.log("Order not created", err);
                      window.location.href = "/checkout-failure";
                    }
                  });
              })
              .catch(function (err) {
                console.log("Payment could not be captured! ", err);
                if (err && err.message === "Error_3DSecure") {
                  // Se è un errore nell'autenticazione 3D Secure non faccio uscire dal checkout
                  document.getElementById("paypal-button-container").style.opacity = 1;
                  document.getElementById("paypal_advanced_cc_button").classList.remove("loader");
                  document.getElementById("paypal_advanced_cc_button").style["border-radius"] = "unset";

                  var divError = document.createElement("div");
                  divError.id = "error_3d_secure";
                  divError.innerHTML = "Errore durante l'autenticazione 3D Secure";
                  divError.style.color = "red";
                  divError.style["margin-left"] = "16px";
                  divError.style["font-size"] = "14px";
                  
                  document.getElementById("paypal_advanced_cc_button_container").appendChild(divError);
                } else {
                  window.location.href = "/checkout-failure";
                }
              });
          });
        });
      } else {
        // Hides card fields if the merchant isn't eligible
        document.querySelector("#card-form").style = "display: none";
      }
    `;

    setTimeout(() => {
      document.body.appendChild(scriptPaypalAdvanced);
    }, 500);
  };

  loadPaypalPayIn3Script = () => {
    const { cartTotalWithExpenses, user, storeId, checkout } = this.props;

    const scriptPaypalPayIn3 = document.createElement('script');
    scriptPaypalPayIn3.id = 'paypal_pay_in_3_script';
    scriptPaypalPayIn3.innerHTML = `
      let orderIdP3;

      var FUNDING_SOURCES = [
        paypal.FUNDING.PAYPAL,
        // paypal.FUNDING.CARD,
      ]

      // Loop over each funding source/payment method
      FUNDING_SOURCES.forEach(function (fundingSource) {
        // Initialize the buttons
        var button = paypal
        .Buttons({
          fundingSource: fundingSource,
          style: {
            layout: "horizontal",
          },
          createOrder: function (data, actions) {
            console.log("createOrder", data, actions);
            return actions.order.create({
              purchase_units: [
                {
                  amount: {
                    value: "${cartTotalWithExpenses.toFixed(2)}"
                  },
                },
              ],
            });
          },
          onApprove: function (createData, actions) {
            document.getElementById("paypal-button-container-pay-in-3").classList.add("loader");
            document.getElementById("paypal-button-container-pay-in-3").style["width"] = "4em";
            document.getElementById("paypal-button-container-pay-in-3").style["margin-bottom"] = "2rem";

            orderIdP3 = createData.orderID;

            console.log("paypal button - paypal order created - now capturing");

            const order = '${JSON.stringify(this.prepareOrder())}';
            const data = {
              ...JSON.parse(order),
              paymentType: "paypal_advanced",
              transactionId: orderIdP3,
            };
            console.log("data", data);
            
            const headers = '${
              checkout.guestCheckout
                ? JSON.stringify(getHeaders(true))
                : JSON.stringify(getAuthHeaders())
            }';

            fetch("${apiUrl}/orders", {
              method: "post",
              headers: {
                storeid: ${storeId},
                ...JSON.parse(headers),
              },
              body: JSON.stringify(data),
            })
              .then(function (res) {
                return res.json();
              })
              .then(function (orderData) {
                // se non c'è orderData.id vuol dire che è fallita la creazione dell'ordine
                if (orderData && orderData.id) {
                  // procedo ad incassare il pagamento e gestisco la risposta da api
                  const data = {
                    orderId: orderData.id
                  };
                  fetch("${apiUrl}/payments/paypal/advanced/capture", {
                    method: "POST",
                    headers: {
                      ${
                        !!localStorage.getItem('token')
                          ? `"Authorization": "Bearer ${localStorage.getItem(
                              'token'
                            )}",`
                          : ''
                      }
                      "storeid": ${storeId},
                    },
                    body: JSON.stringify(data),
                  })
                    .then(function (res) {
                      return res.json();
                    })
                    .then(function (data) {
                      console.log("data", data);
                      window.location.href = data.redirectUrl;
                    })
                    .catch(function (err) {
                      console.log("Error capturing payment", err);
                      window.location.href = "/checkout-failure";
                    })
                } else {
                  console.log("Order not created", err);
                  window.location.href = "/checkout-failure";
                }
              });
          },
        })
        
        // Check if the button is eligible
        if (button.isEligible()) {
          // Render the standalone button for that funding source
          button.render('#paypal-button-container-pay-in-3')
        }
      })
    `;

    setTimeout(() => {
      document.body.appendChild(scriptPaypalPayIn3);
    }, 500);
  };

  setPaymentType = (type, cost) => event => {
    this.props.setPaymentType(type, cost);
  };

  renderCartTotal() {
    return this.props.cart.reduce((total, product) => {
      return total + product.price * product.quantity;
    }, 0);
  }

  saveOrder = event => {
    const order = {
      cartId: localStorage.getItem('cartId'),
      ...this.props.checkout,
    };

    this.setState({
      savingOrder: true,
    });

    // GA CHECKOUT OPTION EVENT
    checkoutStepOptionEvent(4, this.props.checkout.paymentType);

    // GA4 ADD PAYMENT INFO
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4AddPaymentInfo(this.props.cart, this.props.cartTotalWithExpenses, {
        type: this.props.checkout.paymentType,
        cost: this.props.checkout.paymentCost,
      });
    }

    // FKMX ADD PAYMENT INFO
    if (this.props.hasFarmakomMetrics) {
      fkmxAddPaymentInfo(this.props.cart, this.props.cartTotalWithExpenses, {
        type: this.props.checkout.paymentType,
        cost: this.props.checkout.paymentCost,
      });
    }

    this.props.createOrder(order);
  };

  prepareOrder = event => {
    const order = {
      cartId: localStorage.getItem('cartId'),
      ...this.props.checkout,
    };

    // GA CHECKOUT OPTION EVENT
    checkoutStepOptionEvent(4, this.props.checkout.paymentType);

    // GA4 ADD PAYMENT INFO
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4AddPaymentInfo(this.props.cart, this.props.cartTotalWithExpenses, {
        type: this.props.checkout.paymentType,
        cost: this.props.checkout.paymentCost,
      });
    }

    // FKMX ADD PAYMENT INFO
    if (this.props.hasFarmakomMetrics) {
      fkmxAddPaymentInfo(this.props.cart, this.props.cartTotalWithExpenses, {
        type: this.props.checkout.paymentType,
        cost: this.props.checkout.paymentCost,
      });
    }

    let firstProductId = null;
    if (!!sessionStorage) {
      const sessionStorageFirstProductId = sessionStorage.getItem(
        'firstProductId'
      );
      if (
        sessionStorageFirstProductId &&
        sessionStorageFirstProductId !== 'undefined'
      ) {
        firstProductId = sessionStorageFirstProductId;
      }
    }

    const orderToSend = {
      cartId: order.cartId,
      shipping: order.shipping,
      billing: order.billing,
      couponCode: order.coupon.code,
      paymentType: order.paymentType,
      shippingType: order.shippingType,
      slotHour: order.slotHour,
      isInvoiceRequested: !!order.isInvoiceRequested,
      pickupAtPharmacy: !!order.pickupAtPharmacy,
      ricetta: order.ricetta,
      medium: order.medium || null,
      source: order.source || null,
      firstProductId,
    };

    if (order.guestCheckout) {
      orderToSend.user = order.user;
    }

    // if (!!order.pickupLocation && order.pickupLocation.id !== 'store_address') {
    if (!!order.pickupLocation) {
      orderToSend.pickupLocation = order.pickupLocation;
      delete orderToSend.pickupLocation.id;
      delete orderToSend.pickupLocation.storeId;
      delete orderToSend.pickupLocation.createdAt;
    }

    delete orderToSend.pudo;

    return orderToSend;
  };

  renderTotalButtons = isMobile => {
    const { paymentType } = this.props.checkout;
    const { primaryColor, cartTotalWithExpenses } = this.props;
    const { savingOrder } = this.state;

    return (
      <div
        className={`total-buttons ${isMobile ? 'mobile' : 'desktop'}`}
        style={{
          backgroundColor: isMobile ? primaryColor : 'transparent',
        }}
      >
        {!isMobile && <hr className="total-line" />}

        <div className="total">
          <span className="text">Totale da pagare:</span>
          <span className="amount">
            <Price amount={cartTotalWithExpenses} />
          </span>
        </div>

        <div className="buttons">
          <Button
            type="button"
            onClick={() => {
              if (!!savingOrder) {
                window.location.reload();
              }
              this.props.router.push('/spedizione');
            }}
            className={`btn ${
              isMobile ? 'btn-inverse' : 'btn-outline btn-thick'
            }`}
            style={{
              flex: isMobile ? 1 : 'unset',
              color: isMobile ? '#fff' : primaryColor,
              backgroundColor: isMobile ? primaryColor : 'unset',
              margin: 0,
              border: `1px solid ${isMobile ? '#fff' : primaryColor}`,
            }}
          >
            Indietro
          </Button>
          <Button
            type="button"
            disabled={savingOrder || !paymentType}
            onClick={this.saveOrder}
            className={`btn ${
              isMobile ? 'btn-inverse' : 'btn-primary btn-thick'
            }`}
            style={{
              flex: isMobile ? 1 : 'unset',
              color: isMobile ? primaryColor : '#fff',
              backgroundColor: isMobile ? '#fff' : primaryColor,
              margin: 0,
            }}
          >
            {savingOrder && <FaSpinner className="pulse" />}
            Conferma e procedi
          </Button>
        </div>
      </div>
    );
  };

  calcRowsPaymentTypes = () => {
    const { pickupAtPharmacy, shippingType } = this.props.checkout;
    const pudoId = this.props.checkout.shipping.pudoId;
    const { allowCashOnDelivery } = this.props;

    let num = 0;
    if (this.props.hasNexi) {
      num += 1;
    }
    if (this.props.hasPaypal && !this.state.withRicetta) {
      num += 1;
    }
    if (this.props.hasPaypalAdvanced && !this.state.withRicetta) {
      num += 1;
    }
    if (this.props.hasSatispay && !this.state.withRicetta) {
      num += 1;
    }
    if (shippingType === 'ESPRESSO') {
      num += 1;
    }
    if (!pickupAtPharmacy && !pudoId && allowCashOnDelivery) {
      num += 1;
    }

    const rows = num === 4 || num === 2 ? 2 : 3;

    return rows;
  };

  renderPaymentType = (type, title, subtitle, price) => {
    const { paymentType } = this.props.checkout;
    const { primaryColor, uiVariantButton, isMobile } = this.props;

    const isActive = paymentType === type;

    const pagamentoStyle = css`
      {
        border-radius: ${
          uiVariantButton === '1' ? '8px' : uiVariantButton === '3' ? '12px' : 0
        };
        border-color: ${primaryColor};
        &.active {
            background-color: ${primaryColor}!important;
          }
        }
      }
    `;

    const renderRadioIdByType = type => {
      switch (type) {
        case 'credit_card':
          return 'credit-card';
        case 'bonifico':
          return 'bank';
        case 'contrassegno':
          return 'cod';
        case 'satispay':
          return 'sat';
        case 'nexi':
          return 'nexi';
        case 'paypal':
          return 'paypal';
        default:
          return '';
      }
    };

    const renderIcon = type => {
      switch (type) {
        case 'nexi':
          return <CarteNexiOneLine style={{ height: 24, marginLeft: 16 }} />;
        default:
          return null;
      }
    };

    return (
      <div
        className={`payment-type-box ${isActive ? 'active' : ''}`}
        onClick={this.setPaymentType(type, price)}
        css={pagamentoStyle}
        style={{
          flexDirection: 'row',
          margin: '0 8px 16px',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            textAlign: 'left',
            flex: 2,
          }}
        >
          <div
            className="title-price"
            style={{
              alignItems: 'flex-start',
              width: 'fit-content',
            }}
          >
            <div className="payment-title" style={{ fontWeight: 'bold' }}>
              {title}
            </div>
            {subtitle && (
              <div className="payment-subtitle" style={{ margin: 0 }}>
                {subtitle}
              </div>
            )}
          </div>
          {!isMobile && renderIcon(type)}
        </div>

        <div
          className="radio-icon"
          style={{ flexDirection: 'row', alignItems: 'center', flex: 1 }}
        >
          <div
            className="title-price"
            style={{
              marginRight: 8,
              alignItems: isMobile ? 'center' : 'flex-end',
              justifyContent: isMobile ? 'flex-end' : 'center',
            }}
          >
            <div className="payment-price">
              {price === 0 ? 'Gratis' : <Price amount={price} />}
            </div>
          </div>
          <RadioContainer>
            <input
              type="radio"
              id={renderRadioIdByType(type)}
              name="paymentType"
              checked={isActive}
              readOnly
            />
            <label htmlFor={renderRadioIdByType(type)} />
          </RadioContainer>
        </div>
      </div>
    );
  };

  render() {
    const { pickupAtPharmacy, shippingType, paymentType } = this.props.checkout;
    const pudoId = this.props.checkout.shipping.pudoId;
    const { allowCashOnDelivery, primaryColor, isMobile } = this.props;
    const { paypalBoxHeight } = this.state;

    const paymentStyle = css`
      .loader {
        border-left: 0.5em solid ${primaryColor};
        border-radius: 50% !important;
      }
    `;
    return (
      <div className="pagamento" style={{ minWidth: '64%' }} css={paymentStyle}>
        <div
          className="payment-methods"
          // style={{ flexWrap: 'wrap', justifyContent: 'flex-start' }}
          style={{ flexDirection: 'column' }}
        >
          {this.props.hasNexi &&
            this.renderPaymentType(
              'nexi',
              this.props.hasPaypal ||
                this.props.hasPaypalAdvanced ||
                !this.props.hasPaypalInNexi
                ? 'Carta di credito'
                : 'Carta di credito / PayPal',
              this.state.withRicetta
                ? 'La somma effettiva sarà addebitata solo dopo la verifica delle detrazioni fiscali spettanti da parte del farmacista in base alla tua ricetta.'
                : '',
              0
            )}

          {this.props.hasPaypal &&
            !this.state.withRicetta &&
            this.renderPaymentType(
              'paypal',
              this.props.hasNexi ? 'PayPal' : 'Carta di credito / PayPal',
              '',
              0
            )}

          {this.props.hasPaypalAdvanced &&
            !this.state.withRicetta &&
            this.renderPaymentType(
              'paypal_advanced',
              this.props.hasNexi ? 'PayPal' : 'Carta di credito / PayPal',
              '',
              0
            )}

          <div
            style={{
              height: paymentType !== 'paypal_advanced' ? 0 : paypalBoxHeight,
              overflow: 'hidden',
              transition: '0.25s ease-in-out',
            }}
          >
            <div
              id="payload_advanced_box"
              className="paypal"
              style={{ padding: '16px 8px 16px' }}
            >
              <div align="center" style={{ marginBottom: 16 }}>
                {' '}
                Usa il tuo account Paypal{' '}
              </div>
              <table
                // border="0"
                align="center"
                valign="top"
                // bgcolor="#FFFFFF"
                style={{ width: '39%', border: 0 }}
              >
                <tr>
                  <td colSpan={2}>
                    <div id="paypal-button-container"></div>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>&nbsp;</td>
                </tr>
              </table>

              <div align="center">
                Oppure usa la tua carta di credito su circuito Paypal
              </div>
              <div
                align="center"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: isMobile ? 'column' : 'row',
                }}
              >
                Carte accettate:
                <CartePaypal style={{ maxWidth: '90%', width: 240 }} />
              </div>

              <div
                className="card_container"
                style={{ backgroundColor: 'transparent' }}
              >
                <form id="card-form">
                  <label for="card-holder-name">Intestatario</label>
                  <input
                    type="text"
                    id="card-holder-name"
                    name="card-holder-name"
                    autoComplete="off"
                    placeholder="Mario Rossi"
                  />
                  <label for="card-number">Numero Carta</label>
                  <div id="card-number" className="card_field"></div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: 8,
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <label for="expiration-date">Data di scadenza</label>
                      <div id="expiration-date" className="card_field"></div>
                    </div>
                    <div style={{ flex: 1 }}>
                      <label for="cvv">CVV</label>
                      <div id="cvv" className="card_field"></div>
                    </div>
                  </div>
                  {/* <button value="submit" id="submit" className="btn">
                    Pay
                  </button> */}
                  <div
                    id="paypal_advanced_cc_button_container"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginTop: 16,
                    }}
                  >
                    <Button
                      id="paypal_advanced_cc_button"
                      type="submit"
                      className="btn btn-primary btn-thick"
                      style={{
                        color: isMobile ? primaryColor : '#fff',
                        backgroundColor: isMobile ? '#fff' : primaryColor,
                        margin: 0,
                      }}
                    >
                      Paga
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          {/* PAYPAL PAGA IN 3 RATE */}
          {this.props.hasPaypalPayIn3 &&
            !this.state.withRicetta &&
            this.renderPaymentType(
              'paypal_pay_in_3',
              'Paga in 3 rate con Paypal',
              '',
              0
            )}

          <div
            style={{
              height: paymentType !== 'paypal_pay_in_3' ? 0 : 150,
              overflow: 'hidden',
              transition: '0.25s ease-in-out',
            }}
          >
            <div
              id="payload_advanced_box"
              className="paypal"
              style={{ padding: '16px 8px 16px' }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{ width: '40%' }}
                  id="paypal-button-container-pay-in-3"
                ></div>
                <div id="pp-pay-later-message"></div>
              </div>
            </div>
          </div>

          {this.props.hasSatispay &&
            !this.state.withRicetta &&
            this.renderPaymentType('satispay', 'Satispay', '', 0)}

          {!pickupAtPharmacy &&
            !pudoId &&
            allowCashOnDelivery &&
            this.renderPaymentType(
              'contrassegno',
              'Contrassegno al corriere',
              this.state.withRicetta
                ? 'La somma effettiva sarà calcolata solo dopo la verifica delle detrazioni fiscali spettanti da parte del farmacista in base alla tua ricetta.'
                : '',
              this.props.costiSpedizione.priceCashIsRate
                ? Math.round(
                    ((this.props.cartTotal * this.props.importoContrassegno) /
                      100 +
                      Number.EPSILON) *
                      100
                  ) / 100
                : this.props.importoContrassegno
            )}

          {['ESPRESSO', 'PUDO'].some(type => shippingType === type) &&
            !!this.props.bankAccount &&
            this.props.bankAccount !== '' &&
            !this.props.disableBankTransferPayment &&
            this.renderPaymentType(
              'bonifico',
              'Bonifico Bancario',
              "L'ordine sarà lavorato alla ricezione del bonifico",
              0
            )}
        </div>

        {paymentType !== 'paypal_advanced' &&
          paymentType !== 'paypal_pay_in_3' &&
          this.renderTotalButtons(this.props.isMobile)}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isMobile: state.layout.isMobile,
  storeId: state.store.data.id || state.store.data.storeId,
  checkout: state.checkout,
  user: state.user,
  cart: state.cart,
  costiSpedizione: state.store.data.costiSpedizione,
  bankAccount: state.store.data.datiFarmacia.bankAccount,
  disableBankTransferPayment:
    state.store.data.funzionalita.disableBankTransferPayment,
  allowCashOnDelivery: state.store.data.costiSpedizione.allowCashOnDelivery,
  importoContrassegno: state.store.data.costiSpedizione.priceCashondelivery,
  cartTotal: getCartTotalDiscountedCoupon(state),
  cartTotalWithExpenses: getCartTotalWithExpenses(state),
  advancedGa: state.store.data.features.advancedGa,
  hasSatispay: state.store.data.features.hasSatispay,
  hasNexi: state.store.data.features.hasNexi,
  hasPaypal: state.store.data.features.hasPaypal,
  hasPaypalAdvanced: state.store.data.features.hasPaypalAdvanced,
  hasPaypalPayIn3: state.store.data.features.hasPaypalPayIn3,
  primaryColor: state.store.data.loghiTemplate.brandColor,
  uiVariantButton: state.store.data.uiVariants.buttons,
  hasGoogleAnalytics4Advanced: !!state.store.data.features
    .hasGoogleAnalytics4Advanced,
  hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
  hasPaypalInNexi: !!state.store.data.integrazioni.nexi.hasPaypal,
});

Pagamento = connect(mapStateToProps, { setPaymentType, createOrder })(
  Pagamento
);
Pagamento = withRouter(Pagamento);

export default Pagamento;
